var nhsscAccordion = (function () {
const accordionTriggers = document.querySelectorAll( '.accordion-trigger' );

function init() {
  
    if (accordionTriggers) {
      bindUI(accordionTriggers);
    }  

}

function bindUI() {

    Array.prototype.forEach.call(accordionTriggers, accordionTrigger => {
        let target = accordionTrigger.parentElement.nextElementSibling;
        accordionTrigger.onclick = () => {
          let expanded = accordionTrigger.getAttribute('aria-expanded') === 'true' || false;
          accordionTrigger.setAttribute('aria-expanded', !expanded);
          target.hidden = expanded;
        }
      })
}

init();
  
return self;
  
}());
